import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div data-testid="auth-loading" className="min-h-screen flex items-center justify-center text-red-500">
        <span className="uppercase tracking-[0.3em] text-sm blink-cursor">Iniciando sesión</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
